module.exports = __webpack_public_path__ + "static/media/wormhole-bg.ece6c2e1.png";